import React, { useEffect, useRef, useState } from "react";

import DocumentFillManual from "~/atoms/animations/DocumentFillManual";

interface AnimatedDocumentFillProps {
  animationDuration?: number;
  delayDuration?: number;
}

const AnimatedDocumentFill: React.FC<AnimatedDocumentFillProps> = ({
  animationDuration = 5000,
  delayDuration = 1000,
}) => {
  const [percentage, setPercentage] = useState(0);
  const animationFrameRef = useRef<number>(0);
  const startTimeRef = useRef<number>(0);

  useEffect(() => {
    const animate = (currentTime: number) => {
      if (!startTimeRef.current) {
        startTimeRef.current = currentTime;
      }

      const elapsedTime = currentTime - startTimeRef.current;
      const totalCycleDuration = animationDuration * 2 + delayDuration * 2;
      const progress = (elapsedTime % totalCycleDuration) / animationDuration;

      let newPercentage: number;

      if (progress <= 1) {
        // Going up
        newPercentage = progress * 100;
      } else if (progress <= 1 + delayDuration / animationDuration) {
        // Delay at the top
        newPercentage = 100;
      } else if (progress <= 2 + delayDuration / animationDuration) {
        // Going down
        newPercentage =
          (2 + delayDuration / animationDuration - progress) * 100;
      } else {
        // Delay at the bottom
        newPercentage = 0;
      }

      setPercentage(Math.round(newPercentage));

      animationFrameRef.current = requestAnimationFrame(animate);
    };

    animationFrameRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [animationDuration, delayDuration]);

  return <DocumentFillManual percentage={percentage} />;
};

export default AnimatedDocumentFill;
